import angular from 'angular';

angular
  .module('cxSettings')
  .controller('AddEmailDomainDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'suggestedEmailDomain',
    'companyId',
    'companyEmail',
    addEmailDomainDialogCtrl,
  ]);

function addEmailDomainDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  dataCache,
  suggestedEmailDomain,
  companyId,
  companyEmail,
) {
  var vm = this;
  vm.suggestedEmailDomain = suggestedEmailDomain;
  vm.domainRequest = {
    companyId: companyId,
    domain: suggestedEmailDomain,
  };
  vm.companyEmail = companyEmail;
  vm.save = function() {
    vm.saving = true;
    var model = { ...vm.domainRequest };

    $http({
      method: 'post',
      url: appUrls.api + '/api/settings/CreateEmailDomain',
      data: model,
    })
      .then(function(response) {
        var result = response.data;
        $element.modal('hide');
        close(result, 500);
      })
      .catch(function(error) {
        flySvc.error(error);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
